import { render, staticRenderFns } from "./ViewModeSelector.vue?vue&type=template&id=0f9ba554&scoped=true&"
import script from "./ViewModeSelector.vue?vue&type=script&lang=js&"
export * from "./ViewModeSelector.vue?vue&type=script&lang=js&"
import style0 from "./ViewModeSelector.vue?vue&type=style&index=0&id=0f9ba554&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f9ba554",
  null
  
)

/* custom blocks */
import block0 from "./ViewModeSelector.vue?vue&type=custom&index=0&blockType=i18n&lang=yaml"
if (typeof block0 === 'function') block0(component)

/* hot reload */
if (module.hot) {
  var api = require("/home/circleci/project/client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0f9ba554')) {
      api.createRecord('0f9ba554', component.options)
    } else {
      api.reload('0f9ba554', component.options)
    }
    module.hot.accept("./ViewModeSelector.vue?vue&type=template&id=0f9ba554&scoped=true&", function () {
      api.rerender('0f9ba554', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/GalleryView/RatView/ViewModeSelector.vue"
export default component.exports